<template>
  <b-dropdown
    variant="transparent"
    toggle-class="px-2 w-100 border bg-white"
    menu-class="py-0 w-100"
    no-caret
    class="w-100"
  >
    <template #button-content>
      <div class="d-flex justify-content-between align-items-center w-100">
        <span v-if="current === null" class="mx-2 text-13 text-gray-9">
          {{ placeholder }}
        </span>
        <span v-else class="mx-2 text-13">{{ current[keyText] }}</span>
        <i
          class="icon mx-n2 text-24"
          :class="`icon-${icon}`"
          :style="{ lineHeight: '24px' }"
        />
      </div>
    </template>
    <b-dropdown-item
      v-for="(item, i) in items"
      :key="i"
      class="text-13"
      @click="current = item"
    >
      {{ item[keyText] }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    icon: { type: String, default: "caret" },
    value: { type: [String, Number] },
    placeholder: { type: String, default: "" },
    items: { type: Array, default: () => [] },
    keyValue: { type: String, default: "value" },
    keyText: { type: String, default: "text" },
    returnObject: { type: Boolean, default: false },
  },
  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {
      item: this.returnObject
        ? this.value
        : this.items.find((element) => element[this.keyValue] === this.value),
    };
  },
  watch: {
    value(n) {
      this.item = this.returnObject
        ? this.value
        : this.items.find((element) => element[this.keyValue] === this.value);
    },
  },
  computed: {
    current: {
      get({ item }) {
        if (!item) return null;
        return this.returnObject
          ? item
          : this.items.find(
              (element) => element[this.keyValue] === item[this.keyValue]
            );
      },
      set(item) {
        this.$emit("input", this.returnObject ? item : item[this.keyValue]);
        this.item = item;
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
